/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */

import React from 'react';
import { withStyles } from '@material-ui/core/styles';
import Grid from '@material-ui/core/Grid';
import { useUIDSeed } from 'react-uid';
import ReactMarkdown from 'react-markdown';
import {
    string, object, func, bool,
} from 'prop-types';
import ResponsiveImage from '../../../GraphqlCommonComponents/ResponsiveImage/ResponsiveImage';

const styles = (theme) => ({
    dialogContent: {
        fontSize: '.8em',
    },
    subscriptionMessage: {
        fontSize: '.9em',
        padding: '2em 0',
        margin: '1em 0',
        '& span': {
            textDecoration: 'underline',
            cursor: 'pointer',
        },
    },
    subscriptionDetailsContainer: {
        backgroundColor: '#F7F7F7',
        justifyContent: 'center',
    },
    expanded: {
        height: 'fit-content',
        transform: 'scaleY(1)',
        borderTop: '1px solid #D9D9D9',
    },
    minimized: {
        height: '0',
        transform: 'scaleY(0)',
    },
    subscriptionDetails: {
        flexWrap: 'wrap',
        display: 'flex',
        fontSize: 14,
        padding: '0 50px',
        margin: '0 auto',
        '@media screen and (max-width: 600px)': {
            padding: '20px',
            width: '100%',
        },
        '& ul': {
            marginBottom: 0,
            lineHeight: '20px',
            marginTop: 20,
            paddingLeft: 10,
            [theme.breakpoints.down('xs')]: {
                paddingLeft: 40,
                marginTop: 10,
            },

        },
        '& span': {
            textDecoration: 'underline',
            cursor: 'pointer',
            display: 'inline-block',
        },
    },
    dialogHeading: {
        width: '100%',
        display: 'flex',
        justifyContent: 'space-between',
        flex: '0 0 auto',
        '@media screen and (max-width: 600px)': {
            '& >div': {
                width: '80%',
            },
            '& h2': {
                fontSize: '17px',
            },
        },
    },
    closeButton: {
        padding: '16px 24px',
        '@media screen and (max-width: 600px)': {
            padding: '0 0 0 2px',
        },
    },
    closeBtn: {
        position: 'absolute',
        top: '0',
        right: '0',
    },
    popUpHeading: {
        textAlign: 'center',
        '& span': {
            fontSize: '24px',
            [theme.breakpoints.down('md')]: {
                fontSize: '18px',
            },
        },
    },
    bottomContent: {
        margin: '0 auto',
        padding: '20px 0',
        fontSize: '20px',
        fontWeight: '600',
        color: theme.palette.black || '#000',
        textTransform: 'uppercase',
        textDecoration: 'underline',
        '&:hover': {
            backgroundColor: 'inherit',
        },
    },
    copyContent: {
        maxWidth: '274px',
        minWidth: '240px',
        padding: '22px 9px',
        '@media screen and (max-width: 1332px)': {
            maxWidth: '245px',
        },
        '@media screen and (max-width: 600px)': {
            minWidth: '0',
            maxWidth: '100%',
            display: 'flex',
            padding: '8px 0',
        },
        '& p': {
            margin: 0,
            fontSize: '14px',
        },
        '& h5': {
            fontSize: '20px',
            fontWeight: 700,
            margin: 0,
            '@media screen and (max-width: 600px)': {
                fontSize: '16px',
            },
        },
    },
    copyIcon: {
        height: '42px',
        '@media screen and (max-width: 600px)': {
            height: '30px',
            maxWidth: '44px',
            marginRight: '10px',
        },
    },
    tnc: {
        color: theme.palette.primary?.main,
        textAlign: 'center',
        padding: '20px 0',
        cursor: 'pointer',
    },
});

const SubscriptionOfferInformation = ({
    copy, classes, handleModal, toggle,
}) => {
    const seed = useUIDSeed();
    const defaultCopy = (
        <ul>
            <li>Payment method on file will be charged on a recurring basis</li>
            <li>You may cancel through your online account at any time before your next order is processed for delivery or shipment</li>
            <li>To learn more, see <span key={1} role="link" tabIndex={0} onClick={(e) => { handleModal(e, true); }} onKeyDown={(event) => { if (event.keycode === 13); }}>Subscription Program Terms and Conditions</span></li>
        </ul>
    );

    return (
        <>
            <Grid container className={`${classes.subscriptionDetailsContainer} ${toggle ? classes.expanded : classes.minimized}`} data-testid="subscription-details">
                <Grid item xs={12} sm={12}>
                    <div className={classes.subscriptionDetails}>
                        {copy?.offer_copy?.length > 0 ? (
                            <>
                                {copy.offer_copy.map((offer) => (
                                    <div key={seed(offer)} className={classes.copyContent}>
                                        {offer.icon?.url && <ResponsiveImage path={offer.icon?.url} alt={offer.icon?.title} className={classes.copyIcon} params={{}} />}
                                        <div className="content">
                                            {offer.label && <h5>{offer.label}</h5>}
                                            <ReactMarkdown source={offer.copy} escapeHtml={false} />
                                        </div>
                                    </div>
                                ))}
                            </>
                        )
                            : defaultCopy}
                    </div>
                </Grid>
            </Grid>
        </>
    );
};

SubscriptionOfferInformation.propTypes = {
    classes: object.isRequired,
    copy: string.isRequired,
    handleModal: func.isRequired,
    toggle: bool.isRequired,
};

export default  withStyles(styles)(SubscriptionOfferInformation);
